const EV_SEARCH = 'trove_ai_search';
const EV_ASSISTANT = 'trove_ai_assistant';
const EV_BOOKMARK_CONTEXT = 'trove_bookmark_context';

/**
 * Subscribes to AI product analytics CustomEvents and optionally forwards them to a collector.
 * Set `VITE_AI_ANALYTICS_ENDPOINT` to an HTTPS URL that accepts POSTed JSON (e.g. internal ingest).
 */
export function installAiProductAnalyticsForwarding(): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const endpoint = import.meta.env.VITE_AI_ANALYTICS_ENDPOINT as string | undefined;

  const forward = (name: string, detail: unknown) => {
    const payload = JSON.stringify({
      name,
      detail,
      t: Date.now(),
      path: window.location.pathname,
    });
    if (endpoint?.trim()) {
      try {
        navigator.sendBeacon(endpoint.trim(), new Blob([payload], { type: 'application/json' }));
      } catch {
        /* ignore */
      }
    } else if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console -- intentional dev-only sink
      console.debug('[ai-analytics]', name, detail);
    }
  };

  const onSearch = (e: Event) => forward(EV_SEARCH, (e as CustomEvent).detail);
  const onAssistant = (e: Event) => forward(EV_ASSISTANT, (e as CustomEvent).detail);
  const onBookmarkContext = (e: Event) => forward(EV_BOOKMARK_CONTEXT, (e as CustomEvent).detail);

  window.addEventListener(EV_SEARCH, onSearch);
  window.addEventListener(EV_ASSISTANT, onAssistant);
  window.addEventListener(EV_BOOKMARK_CONTEXT, onBookmarkContext);

  return () => {
    window.removeEventListener(EV_SEARCH, onSearch);
    window.removeEventListener(EV_ASSISTANT, onAssistant);
    window.removeEventListener(EV_BOOKMARK_CONTEXT, onBookmarkContext);
  };
}
